import { Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { A7FIATimeSerieFilesTable } from "./table";
import { A7FIATimeSerieFilesEdit } from "./edit";
import { setDocumentTitle } from "@/lib/documentTitle";

export default function A7FIATimeSerieFiles() {
  useEffect(() => {
    setDocumentTitle("Quantilia | FIA Fichiers");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<A7FIATimeSerieFilesEdit />} />
      <Route index element={<A7FIATimeSerieFilesTable />} />
    </Routes>
  );
}
